import React, { useCallback, useEffect, useState } from 'react';
import { Paper, Snackbar, Typography } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert';
import ButtonStartOff from "../../../assets/pip/btn-start-off.png"
import ButtonStartOn from "../../../assets/pip/btn-start-on.png"
import ButtonSkipOff from "../../../assets/pip/btn-skip-off.png"
import ButtonSkiptOn from "../../../assets/pip/btn-skip-on.png"
// import ButtonSkiptRed from "../../../assets/pip/btn-skip-red.png"
import ButtonCallOn from "../../../assets/pip/btn-call-on.png"
import ButtonCallOff from "../../../assets/pip/btn-call-off.png"
import ButtonHold from "../../../assets/pip/btn-hold.png"
import ButtonStop from "../../../assets/pip/btn-stop-red.png"
import CloseImage from '../../../assets/ic_close.png';
import stylePIP from "../styles/pip-page-style.module.css"
import LoadingComponent from '../loading';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" severity='warning' {...props} />;
}

function AntrianPIPPage(props) {

  // satatus : 0=not ready, 1=call,  2=start, 3=hold, 4=skip
  const [currentStatus, setCurrentStatus] = useState(0)
  const [currentStatusTmp, setCurrentStatusTmp] = useState(0)
  const [currentQue, setCurrentQue] = useState([])
  const [nextQue, setNextQue] = useState([])
  const [newNotes, setNewNotes] = useState("")
  const [visibleStop, setVisibleStop] = useState(false)

  const [messageAlert, setMessageAlert] = useState("")
  const [openAlert, setOpenAlert] = useState(false);

  const handleResize = () => {
    console.log('Widht : ' + window.screen.width);
    console.log('Height' + window.screen.height);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  }

  const setDefaultValue = useCallback(
    () => {
      if (props?.dataAntrian?.length > 0) {
        const _curr = props?.dataAntrian[0] || {}
        const _next = currentStatus === 0 ? props?.dataAntrian[0] : props?.dataAntrian[1] || {}
        setCurrentQue(_curr)
        setNextQue(_next)
        switch (props?.statusAntrian) {
          case 'Next':
            setCurrentStatus(1)
            break;
          case 'Proses':
            setCurrentStatus(2)
            break;

          default:
            setVisibleStop(false)
            setCurrentStatus(0)
            break;
        }
      }
    },
    [currentStatus, props?.dataAntrian, props?.statusAntrian],
  )

  useEffect(() => {
    if (props.openAlert) {
      setOpenAlert(props.openAlert)
      setMessageAlert(props.messageAlert)
    } else {
      if (!props.loading) {
        setCurrentStatus(currentStatusTmp === 0 ? 0 : props.messageAlert ? 0 : currentStatusTmp)
      }
      
    }
  }, [currentStatusTmp, props.loading, props.messageAlert, props.openAlert])


  useEffect(() => {
    setDefaultValue()
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setDefaultValue]);

  const getButtonStart = () => {
    switch (currentStatus) {
      case 0:
        return ButtonStartOff
      case 1: ;
        return ButtonStartOn
      case 2:
        return ButtonHold
      default:
        return ButtonStartOff
    };
  }

  const getButtonSkip = () => {
    switch (currentStatus) {
      case 0:
        return ButtonSkipOff
      case 1: ;
        return ButtonSkiptOn
      case 2:
        return ButtonStop
      default:
        return ButtonSkipOff
    };
  }

  return (
    <>
      <LoadingComponent isVisible={props.loading} />
      {/* main container */}
      <div className={stylePIP.mainDiv}>
        {/* box que */}
        <div
          style={{
            width: '100vw',
            backgroundColor: '#ebfbf0'
          }}>

          <div className={stylePIP.boxTitle}>
            <Typography style={{ fontSize: '2vw', fontWeight: 'bold' }}>{props?.docterName} - {props?.polyclinic}</Typography>
          </div>

          <div style={{
            display: 'flex',
            width: '100vw',
          }}>
            <div className={stylePIP.card}>
              <Typography style={{ fontSize: '2vw', fontWeight: 'bolder' }}>Antrian Diproses</Typography>
              <Typography style={{ fontSize: '8vw', fontWeight: 'bold', color: 'green', marginTop: 40 }}>{currentStatus !== 0 && (currentQue?.queue_number || "")}</Typography>
            </div>

            <div className={stylePIP.card}>
              <Typography style={{ fontSize: '2vw', fontWeight: 'bolder' }}>Antrian Selanjutnya</Typography>
              <Typography style={{ fontSize: '8vw', fontWeight: 'bold', color: 'grey', marginTop: 40 }}>{nextQue?.queue_number || ""}</Typography>
            </div>
          </div>
        </div>

        {/* button */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          padding: 20,
          backgroundColor: '#ebfbf0'
        }}>
          <div style={{ cursor: 'pointer', width: '45vw' }}>
            <img src={getButtonStart()} alt='img-left' onClick={() => {
              if (currentStatus === 1) {
                setCurrentStatusTmp(2)
                props.onStart(currentQue)
              } else if (currentStatus === 2) {
                props.onHold(currentQue)
                setCurrentStatusTmp(3)
              }
            }} style={{ width: '35vw' }} />
          </div>
          <div style={{ cursor: 'pointer', width: '25vw' }}>
            <img src={currentStatus === 2 ? ButtonCallOff : ButtonCallOn} alt='img-center' onClick={() => {
              if (currentStatus !== 2) {
                props.onCall(currentQue)
                setCurrentStatusTmp(1)
              }
            }} style={{ width: '20vw' }} />
          </div>
          <div style={{ cursor: 'pointer', width: '45vw' }}>
            <img src={getButtonSkip()} style={{ width: '35vw' }} alt='img-right' onClick={() => {
              if (currentStatus === 1) {
                props.onSkip(currentQue)
                setCurrentStatusTmp(0)
              } else if (currentStatus === 2) {
                setVisibleStop(true)
              }
            }} />
          </div>
        </div>
      </div>

      {visibleStop && (
        <div className="App app-popup-show" style={{ zIndex: 5000 }}>
          <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
              <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                <div className="popup-title">
                  <span style={{ color: 'black', fontSize: 18 }}>Tambah Catatan</span>
                </div>
              </div>
              <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                <button
                  type="button"
                  className="btn btn-circle btn-white"
                  onClick={() => {
                    setVisibleStop(false)
                  }}
                >
                  <img src={CloseImage} alt='CloseImage' />
                </button>
              </div>
            </div>
            <div style={{ height: '30vh' }}>
              <Typography style={{ textAlign: 'start', width: '70%', margin: 'auto', paddingTop: 30 }}>Catatan Baru</Typography>
              <textarea
                label="Catatan Petugas"
                value={newNotes}
                onChange={(e) => {
                  setNewNotes(e.target.value)
                }}
                style={{ width: '70%', marginTop: 10, height: '15vh' }}
                placeholder={"input catatan baru"}
              />
              <Typography style={{ fontSize: 12, color: 'rgb(255, 91, 91)' }}>Note: catatan yang sudah ditambahkan tidak bisa diubah</Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'flex-start', width: '25%' }}>
                <div
                  onClick={() => {
                    props?.onStop(newNotes)
                  }}
                  style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                  <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Paper style={{ boxShadow: 'none' }} >
        <div style={{ width: '100%', display: 'grid', backgroundColor: 'white' }}>
          <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleCloseAlert}>
            <div style={{ backgroundColor: '#ff9800', borderRadius: 8 }}>
              <p style={{ color: 'white', margin: 12 }}>{messageAlert}</p>
            </div>
          </Snackbar>
        </div>
      </Paper>

    </>
  )
}

export default AntrianPIPPage;